import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, UUID, COLLECTION } from '@/plugins/sdk/fields'
import FuelIndex from '@/plugins/sdk/resources/Fuel/Index'
import Fuel from '@/plugins/sdk/resources/Fuel'

export default class extends Resource {
  static name = 'fuel_group'

  static get fields () {
    return {
      id: new UUID(),
      deleted: new BOOLEAN(),
      deleted_date: new DATETIME(),
      indices: new COLLECTION(FuelIndex),
      fuels: new COLLECTION(Fuel)
    }
  }
}
